import {SkuFoodCategoryCountType} from "../../../../common/types";
import ReactApexChart from "react-apexcharts";
import React from "react";
import {Card} from "antd";

// Тип пропсов для компонента: ожидает массив данных по категориям и параметры фильтрации
type LevelCategoriesChartType = {
    data: SkuFoodCategoryCountType[]
    city: string
    store_name: string
    level_category: string
}

export const LevelCategoriesChart = ({data, level_category, store_name, city}: LevelCategoriesChartType) => {

    // Массив для значений (количество позиций)
    const series: number[] = []
    // Массив для названий категорий
    const categories: string[] = []
    // Переменная для самой длинной категории (используется для высоты меток)
    let categoriesNameLength = data[0]?.name_category

    // Заполнение массивов для графика и определение максимальной длины названия категории
    data.forEach((el) => {
        const name = el.name_category?.replace('Мелкоштучные хлебные изделия', 'МХИ')
        series.push(el.quantity_positions)
        categories.push(name)
        if (name.length > categoriesNameLength.length) categoriesNameLength = name
    })

    // Базовая ширина графика и расчет ширины при большом количестве столбцов
    const baseWidth = 965; // базовая ширина контейнера (до 30 столбцов)
    const extraWidthPerBar = 34; // дополнительная ширина на каждый столбик сверх 30
    let chartWidth = baseWidth;

    if (data.length > 30) {
        chartWidth += (data.length - 30) * extraWidthPerBar;
    }

    // Опции для ApexCharts: настройки графика, осей, сетки, подписей, цветов, тултипа и легенды
    const options = {
        chart: {
            type: 'bar' as const,
            height: 350,
            toolbar: {
                show: false
            },
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                borderRadiusApplication: 'end' as const,
                horizontal: false,
                distributed: true,
            }
        },
        title: {
            text: `Количество товаров в каждой категории (${level_category})`,
            align: data.length > 30 ? 'left' as const : 'center' as const  ,
            margin: 20,
            style: {

                fontSize: '16px',
                fontWeight: 'bold' as const,
                color: '#FFFFFF'
            },
        },
        subtitle: {
            text: `${city} / ${store_name}`,
            align: data.length > 30 ? 'left' as const : 'center' as const  ,
            margin: 20,
            style: {

                fontSize: '12px',
                fontWeight: 'bold' as const,
                color: '#FFFFFF'
            },
        },
        colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
            '#f48024', '#69d2e7'
        ],
        xaxis: {
            categories,
            labels: {
                minHeight: categoriesNameLength?.length * 5.1,
                style: {
                    colors: 'white',
                    fontWeight: 14,
                    fontSize: '12',
                },
                rotate: -45, // Добавлено: поворот меток для лучшего отображения
                hideOverlappingLabels: false, // Гарантирует отображение всех меток
                trim: false, // Не обрезать метки
            },

            tooltip: {
                enabled: true
            }
        },
        grid: {
            show: false
        },
        yaxis: {
            labels: {
                show: false
            }
        },
        tooltip: {
            enabled: true,
            theme: 'dark',
            x: {
                show: true,
            },
            y: {
                title: {
                    formatter: function () {
                        return 'Количество продуктов'
                    }
                }
            },
            marker: {
                show: true,
            },
        },
        legend: {
            show: false
        }
    }

    // Отрисовка карточки с графиком распределения по категориям
    return (
        <Card style={{
            backgroundColor: '#293133',
            borderRadius: 20,
            paddingLeft: 20,
            paddingRight: 20,
            width: '100%',
            overflowX: 'auto'
        }}>
            {/* График распределения по категориям ApexCharts */}
            <ReactApexChart
                options={options}
                series={[{data: series}]}
                type={'bar'}
                height={500}
                style={{color: '#FFFFFF'}}
                width={chartWidth}
            />
        </Card>
    );
};
